export default __webpack_public_path__ + "assets/svg/trainer_connect_logo.84b53f8eb69c70134b7b632b7a9c7c31.svg";